import { Badge, ListGroup, Stack } from 'react-bootstrap';
import QuantityControl from 'features/product/QuantityControl';
import './OrderDetails.css';
import { sumBy } from 'lodash';

const OrderDetails = ({ products, editable = true }) => {
  const totalPrice = sumBy(
    products,
    (product) => product.price * product.quantity
  );

  return (
    <>
      <ListGroup as="ol" numbered variant="flush">
        {products.map((product) => (
          <ListGroup.Item
            key={product.id}
            as="li"
            className="d-flex justify-content-between align-items-start"
          >
            <img
              // src={`${process.env.REACT_APP_API}/${product.image}`}
              // alt={`${product.name} image`}
              src={product.image}
              alt={product.title}
              className="ms-2 order-details-image"
            />
            <div className="ms-2 flex-grow-1">
              {/* <div className="fw-bold">{product.name}</div> */}
              <div className="fw-bold">{product.title}</div>
              {editable ? (
                <QuantityControl product={product}></QuantityControl>
              ) : (
                <Stack direction="horizontal">
                  <span>Qty:</span>
                  <Badge className="ms-2">{product.quantity}</Badge>
                  <span className="ms-2">Price: </span>
                  <Badge className="ms-2">
                    {product.price.toLocaleString()}
                  </Badge>
                </Stack>
              )}
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
      <hr />
      <Stack direction="horizontal">
        <div>Total</div>
        <div className="ms-auto">{totalPrice.toLocaleString()}</div>
      </Stack>
    </>
  );
};

export default OrderDetails;
